export default __webpack_public_path__ + "static/media/img_7576.07f3f56b.jpeg";